var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/upload-progress.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { spring } from 'react-motion';
import { HStack, Icon, Stack, Text } from 'soapbox/components/ui';
import Motion from 'soapbox/features/ui/util/optional_motion';
/** Displays a progress bar for uploading files. */
const UploadProgress = ({
  progress
}) => {
  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/cloud-upload.svg'),
    className: "w-7 h-7 text-gray-500",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    space: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "upload_progress.label",
    defaultMessage: "Uploading\u2026",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-1.5 rounded-lg bg-gray-200 relative",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Motion, {
    defaultStyle: {
      width: 0
    },
    style: {
      width: spring(progress)
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 11
    }
  }, ({
    width
  }) => /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 top-0 h-1.5 bg-primary-600 rounded-lg",
    style: {
      width: `${width}%`
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30,
      columnNumber: 16
    }
  })))));
};
export default UploadProgress;